/* ==========================================================================
   gift-option.js  ·  Opción de regalo en el carrito · Monaco 1.2.4
   --------------------------------------------------------------------------
   - Se carga UNA vez desde el snippet (con defer). Al usar delegación de
     eventos a nivel document, sigue funcionando aunque Monaco vuelva a
     renderizar el carrito con innerHTML (que descarta scripts incrustados).
   - Guarda los datos como atributos del carrito vía /cart/update.js:
         Regalo            -> "Sí"
         Mensaje de regalo -> texto
     Esos atributos se copian a la orden (admin -> Detalles adicionales).
   ========================================================================== */
(function () {
  'use strict';

  if (window.__giftOptionBound) return;
  window.__giftOptionBound = true;

  var FLAG_KEY = 'Regalo';
  var MSG_KEY = 'Mensaje de regalo';
  var msgTimer = null;

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function updateCart(attrs) {
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {
      /* silencioso: no romper el carrito si falla la red */
    });
  }

  function syncCount(root) {
    if (!root) return;
    var ta = root.querySelector('[data-gift-message]');
    var counter = root.querySelector('[data-gift-count]');
    if (ta && counter) counter.textContent = String(ta.value.length);
  }

  // Checkbox: abre/cierra el panel (por clase) y guarda la bandera
  document.addEventListener('change', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-gift-toggle]');
    if (!toggle) return;

    var root = toggle.closest('[data-gift-option]');
    var ta = root ? root.querySelector('[data-gift-message]') : null;
    var attrs = {};

    if (toggle.checked) {
      if (root) root.setAttribute('data-gift-open', '');
      attrs[FLAG_KEY] = 'Sí';
      updateCart(attrs);
    } else {
      if (root) root.removeAttribute('data-gift-open');
      if (ta) ta.value = '';
      attrs[FLAG_KEY] = '';
      attrs[MSG_KEY] = '';
      updateCart(attrs);
      syncCount(root);
    }
  });

  // Mensaje: guarda con debounce mientras se escribe
  document.addEventListener('input', function (e) {
    var ta = e.target.closest && e.target.closest('[data-gift-message]');
    if (!ta) return;

    var root = ta.closest('[data-gift-option]');
    syncCount(root);

    clearTimeout(msgTimer);
    msgTimer = setTimeout(function () {
      var attrs = {};
      attrs[MSG_KEY] = ta.value;
      updateCart(attrs);
    }, 500);
  });
})();